var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"8","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 1.443L.943.5l3.058 3.113L7.057.5 8 1.443 4.001 5.5 0 1.443z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }